<template>
  <Breadcrumbs main="Administración" title="Formularios" />
  <div class="container-fluid">
    <div class="row project-cards">
      <TopMenu
        @formCreated="reloadTable"
        @viewChanged="handleViewChange"
        @searchChanged="handleSearchChange"
        @filterChanged="handleFilterChange"
        :currentView="currentView"
      />
      <TableForAdmins
        ref="tableRef"
        :items="filteredItems"
        :loading="loading"
        @stateChanged="handleStateChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import axios from "@/includes/connection";
import { toast } from "vue3-toastify";
import TopMenu from "./components/TopMenuAdmin.vue";
import TableForAdmins from "./components/TableFormsAdmin.vue";

const tableRef = ref(null);
const currentView = ref("mis-formularios");
const searchQuery = ref("");
const selectedFilter = ref("Sin Filtro");
const allForms = ref([]);
const loading = ref(false);

const viewFilteredItems = computed(() => {
  return allForms.value;
});

const filteredItems = computed(() => {
  let filtered = viewFilteredItems.value;

  if (searchQuery.value.trim()) {
    const query = searchQuery.value.toLowerCase().trim();
    filtered = filtered.filter(
      (item) =>
        item.detail.toLowerCase().includes(query) ||
        item.description.toLowerCase().includes(query) ||
        item.user.toLowerCase().includes(query)
    );
  }

  if (selectedFilter.value !== "Sin Filtro") {
    filtered = filtered.filter((item) => item.type === selectedFilter.value);
  }

  return filtered.sort((a, b) => new Date(b.id) - new Date(a.id));
});

function loadItems() {
  loading.value = true;
  axios
    .get("/enrollment-form")
    .then((response) => {
      if (response.data) {
        allForms.value = response.data;
        //console.log("Formularios cargados:", response.data.length);
      }
    })
    .catch((error) => {
      console.error("Error loading forms:", error);
      toast.error("Error al cargar los formularios");
    })
    .finally(() => {
      loading.value = false;
    });
}

function handleStateChange(formId) {
  axios
    .patch(`/enrollment-form/${formId}`)
    .then((response) => {
      toast.success("Estado del formulario actualizado exitosamente!");
      //loadItems();
    })
    .catch((error) => {
      console.error("Error updating state:", error);
      toast.error("Error al actualizar el estado del formulario");
    });
}

function reloadTable() {
  loadItems();
}

function handleViewChange(view) {
  currentView.value = view;
  searchQuery.value = "";
  selectedFilter.value = "Todos";
}

function handleSearchChange(query) {
  searchQuery.value = query;
}

function handleFilterChange(filter) {
  selectedFilter.value = filter;
}

onMounted(() => {
  loadItems();
});
</script>
